import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import TextField from "@mui/material/TextField";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Modal from "@mui/material/Modal";
import FormControl from "@mui/material/FormControl";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CloseIcon from "@mui/icons-material/Close";
import Themgiaypheplaixe from "components/Danhmuc/Laixe/Chitiet/Themgiaypheplaixe.js";
import Themgiaykhamsuckhoe from "components/Danhmuc/Laixe/Chitiet/Themgiaykhamsuckhoe.js";
import Themhopdonglaodong from "components/Danhmuc/Laixe/Chitiet/Themhopdonglaodong.js";
import Themtaphuannv from "components/Danhmuc/Laixe/Chitiet/Themtaphuannv.js";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import Config from "conFig.js";
import styles from "assets/jss/material-dashboard-react/components/tableviewStyle.js";
import { Error, Success } from "../../../assets/jss/util/messageUtil";

const useStyles = makeStyles(styles);
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const gplxcolumn = [
  {
    field: "stt",
    headerName: "STT",
    width: 80,
    headerAlign: "center",
  },
  {
    field: "sogplx",
    headerName: "Số GPLX",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "hanggplx",
    headerName: "Hạng GPLX",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "ngaycap",
    headerName: "Ngày cấp",
    width: 190,
    headerAlign: "center",
  },
  {
    field: "ngayhethan",
    headerName: "Ngày hết hạn",
    width: 190,
    headerAlign: "center",
  },
];
const gkskcolumn = [
  {
    field: "stt",
    headerName: "STT",
    width: 80,
    headerAlign: "center",
  },
  {
    field: "donvicap",
    headerName: "Đơn vị cấp",
    width: 280,
    headerAlign: "center",
  },
  {
    field: "sogiayksk",
    headerName: "Số GKSK",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "ngaycap",
    headerName: "Ngày cấp",
    width: 190,
    headerAlign: "center",
  },
  {
    field: "ngayhethan",
    headerName: "Ngày hết hạn",
    width: 190,
    headerAlign: "center",
  },
];
const hdcolumn = [
  {
    field: "stt",
    headerName: "STT",
    width: 80,
    headerAlign: "center",
  },
  {
    field: "sohdld",
    headerName: "Số hợp đồng",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "ngay_batdau",
    headerName: "Ngày bắt đầu",
    width: 140,
    headerAlign: "center",
  },
  {
    field: "ngay_ketthuc",
    headerName: "Ngày kết thúc",
    width: 140,
    headerAlign: "center",
  },
  {
    field: "ten_loaihd",
    headerName: "Loại hợp đồng",
    width: 220,
    headerAlign: "center",
  },
  {
    field: "trangthaihd",
    headerName: "Trạng thái",
    width: 210,
    headerAlign: "center",
  },
];
const thcolumn = [
  {
    field: "stt",
    headerName: "STT",
    width: 80,
    headerAlign: "center",
  },
  {
    field: "sogcn",
    headerName: "Số GCN",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "ngaycap",
    headerName: "Ngày cấp",
    width: 190,
    headerAlign: "center",
  },
  {
    field: "thoihan",
    headerName: "Ngày hết hạn",
    width: 190,
    headerAlign: "center",
  },
  {
    field: "donvicap",
    headerName: "Đơn vị cấp",
    width: 280,
    headerAlign: "center",
  },
];
const Capnhatlaixe = React.memo(function Capnhatlaixe(props) {
  const { laixe_id } = props;
  const classes = useStyles();
  const [hoten, setHoten] = React.useState("");
  const [ngaysinh, setNgaysinh] = React.useState(dayjs());
  const [cmnd, setCmnd] = React.useState("");
  const [ngaycapcmnd, setNgaycapcmnd] = React.useState(dayjs());
  const [diachi, setDiachi] = React.useState("");
  const [sodienthoai, setSodienthoai] = React.useState("");
  const [giaypheplaixe, setGiaypheplaixe] = React.useState([]);
  const [giaypheplaixect, setGiaypheplaixect] = React.useState("");
  const [giaykhamsuckhoe, setGiaykhamsuckhoe] = React.useState([]);
  const [giayksk_id, setGiayksk_id] = React.useState(0);
  const [hopdong, setHopdong] = React.useState([]);
  const [hdld_id, setHdld_id] = React.useState(0);
  const [taphuannv, setTaphuannv] = React.useState([]);
  const [taphuannv_id, setTaphuannv_id] = React.useState(0);
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [alertValidate, setAlertValidate] = React.useState(false);
  const [messageValidate, setMessageValidate] = React.useState("");
  const [disableBT, setDisableBT] = React.useState(true);
  const [disableBT1, setDisableBT1] = React.useState(true);
  const [disableBT2, setDisableBT2] = React.useState(true);
  const [disableBT3, setDisableBT3] = React.useState(true);
  const [openthemgplx, setOpenthemgplx] = React.useState(false);
  const [openthemgksk, setOpenthemgksk] = React.useState(false);
  const [openthemhopdong, setOpenthemhopdong] = React.useState(false);
  const [openthemtaphuannv, setOpenthemtaphuannv] = React.useState(false);
  const handleClosegplx = () => {
    setOpenthemgplx(false);
    getgiayphep();
  };
  const handleClosegksk = () => {
    setOpenthemgksk(false);
    getgiaykhamsuckhoe();
  };
  const handleClosehopdong = () => {
    setOpenthemhopdong(false);
    gethopdonglaodong();
  };
  const handleClosetaphuannv = () => {
    setOpenthemtaphuannv(false);
    gettaphuannghiepvu();
  };
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getlaixetheoid = () => {
    var url =
      Config.backend +
      "/api/Donvi/getlaixeid?id=" +
      laixe_id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setHoten(data[0].hoten);
        let [day, month, year] = data[0].ngaysinh.split("/");
        setNgaysinh(dayjs(year + "-" + month + "-" + day));
        setCmnd(data[0].cmnd);
        let [day1, month1, year1] = data[0].ngaycapcmnd.split("/");
        setNgaycapcmnd(dayjs(year1 + "-" + month1 + "-" + day1));
        setDiachi(data[0].diachi);
        setSodienthoai(data[0].sodienthoai);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const updatelaixe = () => {
    let mess = validateCapnhat();
    if (mess === Success.SC0001) {
      var ngaythangsinh =
        ngaysinh.$y +
        "-" +
        String(ngaysinh.$M + 1).padStart(2, "0") +
        "-" +
        ngaysinh.$D;
      var ngaycapcm =
        ngaycapcmnd.$y +
        "-" +
        String(ngaycapcmnd.$M + 1).padStart(2, "0") +
        "-" +
        ngaycapcmnd.$D;
      var url = Config.backend + "/api/Donvi/capnhatlaixe";
      fetch(url, {
        method: "PUT",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          id: laixe_id,
          hoten: hoten,
          ngaysinh: ngaythangsinh,
          cmnd: cmnd,
          sodienthoai: sodienthoai,
          ngaycapcmnd: ngaycapcm,
          diachi: diachi,
          username: username,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data === 1) {
            showNotification();
          } else showNotification1();
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    } else {
      setMessageValidate(mess);
      showNotificationValidate();
    }
  };
  const getgiayphep = () => {
    var url =
      Config.backend +
      "/api/Donvi/getlaixegplxtheolxid?laixe_id=" +
      laixe_id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setGiaypheplaixe(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getgiaykhamsuckhoe = () => {
    var url =
      Config.backend +
      "/api/Donvi/getlaixegksktheolaixeid?laixe_id=" +
      laixe_id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setGiaykhamsuckhoe(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const gethopdonglaodong = () => {
    var url =
      Config.backend +
      "/api/Donvi/getlaixehdldtheolaixeid?laixe_id=" +
      laixe_id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setHopdong(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const gettaphuannghiepvu = () => {
    var url =
      Config.backend +
      "/api/Phuongtien/getgcnlaixeid?laixe_id=" +
      laixe_id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setTaphuannv(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const xoagiaypheplaixe = () => {
    var url = Config.backend + "/api/Donvi/xoalaixegplx";
    fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        laixe_id: laixe_id,
        sogplx: giaypheplaixect,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          setMessageValidate(data);
          showNotificationValidate();
          getgiayphep();
          setDisableBT(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const xoagiaykhamsuckhoe = () => {
    var url = Config.backend + "/api/Donvi/xoalaixeksk";
    fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        laixe_id: laixe_id,
        giayksk_id: giayksk_id,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          setMessageValidate(data);
          showNotificationValidate();
          getgiaykhamsuckhoe();
          setDisableBT1(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const xoahopdong = () => {
    var url = Config.backend + "/api/Donvi/xoalaixehdld";
    fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        laixe_id: laixe_id,
        hdld_id: hdld_id,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          setMessageValidate(data);
          showNotificationValidate();
          gethopdonglaodong();
          setDisableBT2(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const xoataphuannv = () => {
    var url = Config.backend + "/api/Phuongtien/xoagnclaixeid";
    fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        laixe_id: laixe_id,
        gcn_id: taphuannv_id,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          setMessageValidate(data);
          showNotificationValidate();
          gettaphuannghiepvu();
          setDisableBT3(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const showNotificationValidate = () => {
    setAlertValidate(true);
    setTimeout(function () {
      setAlertValidate(false);
    }, 6000);
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  // const disablebutton = () => {
  //   if (cmnd.trim().length > 0 && hoten.trim().length > 0) {
  //     setDisableBT(false);
  //   } else {
  //     setDisableBT(true);
  //   }
  // };
  const validateCapnhat = () => {
    // Kiem tra cac truong bat buoc nhap
    if (cmnd.trim() === "") {
      return Error.ER0059;
    }
    if (hoten.trim() === "") {
      return Error.ER0060;
    }
    return Success.SC0001;
  };
  // React.useEffect(() => {
  //   disablebutton();
  // }, [hoten, cmnd]);
  React.useEffect(() => {
    getlaixetheoid();
    getgiayphep();
    getgiaykhamsuckhoe();
    gethopdonglaodong();
    gettaphuannghiepvu();
  }, []);
  return (
    <div style={{ height: 550, overflowY: "auto" }}>
      <CardBody>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Họ tên"
                variant="outlined"
                size="small"
                value={hoten}
                onChange={(event) => {
                  setHoten(event.target.value);
                }}
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày tháng năm sinh"
                  value={ngaysinh}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setNgaysinh(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Số điện thoại"
                variant="outlined"
                size="small"
                value={sodienthoai}
                onChange={(event) => {
                  setSodienthoai(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Số CMND/CCCD"
                variant="outlined"
                size="small"
                value={cmnd}
                onChange={(event) => {
                  setCmnd(event.target.value);
                }}
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày cấp CMND/CCCD"
                  value={ngaycapcmnd}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setNgaycapcmnd(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Địa chỉ"
                variant="outlined"
                size="small"
                value={diachi}
                onChange={(event) => {
                  setDiachi(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "15%", marginTop: "8px" }}>
              <Button
                color="warning"
                variant="contained"
                //disabled={disableBT}
                onClick={updatelaixe}
                style={{ height: "25px" }}
              >
                Cập nhật
              </Button>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <FormControl style={{ width: "100%", fontWeight: "bold" }}>
              1. Giấy phép lái xe
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <div style={{ height: 180, width: "100%", marginTop: 8 }}>
              <DataGrid
                getRowId={(row) => row.stt}
                rows={giaypheplaixe}
                columns={gplxcolumn}
                onRowClick={(params) => {
                  setGiaypheplaixect(params.row.sogplx);
                  setDisableBT(false);
                }}
                checkboxSelection={false}
                getRowHeight={() => "auto"}
                headerHeight={35}
                hideFooter={true}
                sx={datagridSx}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <FormControl style={{ width: "10%" }}>
              <Button
                color="warning"
                variant="contained"
                onClick={() => setOpenthemgplx(true)}
                style={{ height: "25px" }}
              >
                Thêm
              </Button>
            </FormControl>
            <FormControl style={{ width: "10%", marginLeft: 10 }}>
              <Button
                color="error"
                variant="contained"
                disabled={disableBT}
                onClick={xoagiaypheplaixe}
                style={{ height: "25px" }}
              >
                Xóa
              </Button>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <FormControl style={{ width: "100%", fontWeight: "bold" }}>
              2. Giấy khám sức khỏe
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <div style={{ height: 180, width: "100%", marginTop: 8 }}>
              <DataGrid
                getRowId={(row) => row.stt}
                rows={giaykhamsuckhoe}
                columns={gkskcolumn}
                onRowClick={(params) => {
                  setGiayksk_id(params.row.id);
                  setDisableBT1(false);
                }}
                checkboxSelection={false}
                getRowHeight={() => "auto"}
                headerHeight={35}
                hideFooter={true}
                sx={datagridSx}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <FormControl style={{ width: "10%" }}>
              <Button
                color="warning"
                variant="contained"
                onClick={() => setOpenthemgksk(true)}
                style={{ height: "25px" }}
              >
                Thêm
              </Button>
            </FormControl>
            <FormControl style={{ width: "10%", marginLeft: 10 }}>
              <Button
                color="error"
                variant="contained"
                disabled={disableBT1}
                onClick={xoagiaykhamsuckhoe}
                style={{ height: "25px" }}
              >
                Xóa
              </Button>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <FormControl style={{ width: "100%", fontWeight: "bold" }}>
              3. Hợp đồng lao động
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <div style={{ height: 180, width: "100%", marginTop: 8 }}>
              <DataGrid
                getRowId={(row) => row.stt}
                rows={hopdong}
                columns={hdcolumn}
                onRowClick={(params) => {
                  setHdld_id(params.row.id);
                  setDisableBT2(false);
                }}
                checkboxSelection={false}
                getRowHeight={() => "auto"}
                headerHeight={35}
                hideFooter={true}
                sx={datagridSx}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <FormControl style={{ width: "10%" }}>
              <Button
                color="warning"
                variant="contained"
                onClick={() => setOpenthemhopdong(true)}
                style={{ height: "25px" }}
              >
                Thêm
              </Button>
            </FormControl>
            <FormControl style={{ width: "10%", marginLeft: 10 }}>
              <Button
                color="error"
                variant="contained"
                disabled={disableBT2}
                onClick={xoahopdong}
                style={{ height: "25px" }}
              >
                Xóa
              </Button>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <FormControl style={{ width: "100%", fontWeight: "bold" }}>
              4. GCN tập huấn nghiệp vụ vận tải
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <div style={{ height: 180, width: "100%", marginTop: 8 }}>
              <DataGrid
                getRowId={(row) => row.stt}
                rows={taphuannv}
                columns={thcolumn}
                onRowClick={(params) => {
                  setTaphuannv_id(params.row.id);
                  setDisableBT3(false);
                }}
                checkboxSelection={false}
                getRowHeight={() => "auto"}
                headerHeight={35}
                hideFooter={true}
                sx={datagridSx}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <FormControl style={{ width: "10%" }}>
              <Button
                color="warning"
                variant="contained"
                onClick={() => setOpenthemtaphuannv(true)}
                style={{ height: "25px" }}
              >
                Thêm
              </Button>
            </FormControl>
            <FormControl style={{ width: "10%", marginLeft: 10 }}>
              <Button
                color="error"
                variant="contained"
                disabled={disableBT3}
                onClick={xoataphuannv}
                style={{ height: "25px" }}
              >
                Xóa
              </Button>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={10} md={12}>
            <Modal
              open={openthemgplx}
              onClose={handleClosegplx}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <div>
                <GridContainer>
                  <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
                  <GridItemLogin xs={12} sm={12} md={4}>
                    <Card>
                      <CardHeader color="primary" style={{ height: 10 }}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} md={10}>
                            <FormControl
                              style={{ width: "100%", marginTop: "10px" }}
                            >
                              <h6
                                className={classes.cardTitleWhite}
                                style={{ marginTop: "-5px" }}
                              >
                                Thêm giấy phép lái xe
                              </h6>
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={1}></GridItem>
                          <GridItem xs={12} sm={12} md={1}>
                            <FormControl
                              style={{ width: "100%", marginTop: "1px" }}
                            >
                              <CloseIcon onClick={handleClosegplx} />
                            </FormControl>
                          </GridItem>
                        </GridContainer>
                      </CardHeader>
                      <Themgiaypheplaixe laixe_id={laixe_id} />
                    </Card>
                  </GridItemLogin>
                  <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
                </GridContainer>
              </div>
            </Modal>
          </GridItem>
          <GridItem xs={12} sm={10} md={12}>
            <Modal
              open={openthemgksk}
              onClose={handleClosegksk}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <div>
                <GridContainer>
                  <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
                  <GridItemLogin xs={12} sm={12} md={4}>
                    <Card>
                      <CardHeader color="primary" style={{ height: 10 }}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} md={10}>
                            <FormControl
                              style={{ width: "100%", marginTop: "10px" }}
                            >
                              <h6
                                className={classes.cardTitleWhite}
                                style={{ marginTop: "-5px" }}
                              >
                                Thêm giấy khám sức khỏe
                              </h6>
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={1}></GridItem>
                          <GridItem xs={12} sm={12} md={1}>
                            <FormControl
                              style={{ width: "100%", marginTop: "1px" }}
                            >
                              <CloseIcon onClick={handleClosegksk} />
                            </FormControl>
                          </GridItem>
                        </GridContainer>
                      </CardHeader>
                      <Themgiaykhamsuckhoe laixe_id={laixe_id} />
                    </Card>
                  </GridItemLogin>
                  <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
                </GridContainer>
              </div>
            </Modal>
          </GridItem>
          <GridItem xs={12} sm={10} md={12}>
            <Modal
              open={openthemhopdong}
              onClose={handleClosehopdong}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <div>
                <GridContainer>
                  <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
                  <GridItemLogin xs={12} sm={12} md={4}>
                    <Card>
                      <CardHeader color="primary" style={{ height: 10 }}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} md={10}>
                            <FormControl
                              style={{ width: "100%", marginTop: "10px" }}
                            >
                              <h6
                                className={classes.cardTitleWhite}
                                style={{ marginTop: "-5px" }}
                              >
                                Thêm hợp đồng lao động
                              </h6>
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={1}></GridItem>
                          <GridItem xs={12} sm={12} md={1}>
                            <FormControl
                              style={{ width: "100%", marginTop: "1px" }}
                            >
                              <CloseIcon onClick={handleClosehopdong} />
                            </FormControl>
                          </GridItem>
                        </GridContainer>
                      </CardHeader>
                      <Themhopdonglaodong laixe_id={laixe_id} />
                    </Card>
                  </GridItemLogin>
                  <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
                </GridContainer>
              </div>
            </Modal>
          </GridItem>
          <GridItem xs={12} sm={10} md={12}>
            <Modal
              open={openthemtaphuannv}
              onClose={handleClosetaphuannv}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <div>
                <GridContainer>
                  <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
                  <GridItemLogin xs={12} sm={12} md={4}>
                    <Card>
                      <CardHeader color="primary" style={{ height: 10 }}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} md={10}>
                            <FormControl
                              style={{ width: "100%", marginTop: "10px" }}
                            >
                              <h6
                                className={classes.cardTitleWhite}
                                style={{ marginTop: "-5px" }}
                              >
                                Thêm GCN tập huấn nghiệp vụ vận tải
                              </h6>
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={1}></GridItem>
                          <GridItem xs={12} sm={12} md={1}>
                            <FormControl
                              style={{ width: "100%", marginTop: "1px" }}
                            >
                              <CloseIcon onClick={handleClosetaphuannv} />
                            </FormControl>
                          </GridItem>
                        </GridContainer>
                      </CardHeader>
                      <Themtaphuannv laixe_id={laixe_id} />
                    </Card>
                  </GridItemLogin>
                  <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
                </GridContainer>
              </div>
            </Modal>
          </GridItem>
        </GridContainer>
      </CardBody>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Cập nhật thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình cập nhật"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={messageValidate}
            open={alertValidate}
            closeNotification={() => setAlertValidate(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
});

Capnhatlaixe.propTypes = {
  laixe_id: PropTypes.number,
};
export default Capnhatlaixe;
